import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Logo from './Logo';
import Slider from './Slider';
import Headlines from './Headlines';
import Nav from './Nav';
import Schedule from './Schedule';
import ShooterList from './ShooterList';
import Original from './Original';
import VideoColumn from './VideoColumn';
import Wonderful from './Wonderful';
import Integral from './Integral';
import Customer from './Customer';
import News from './News';
import Thanks from './Thanks';
import Footer from '@src/pc/components/Footer';
import BannerAd from './BannerAd';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {
    const {
        nav,
        slider,
        headlines1,
        headlines2,
        scheduleHead,
        shooteHead,
        originalHead,
        originalFeed,
        videoColumnHead,
        videoColumnFeed,
        tabNameHead,
        wonderful,
        wonderfulHead,
        customer,
        customerHead,
        news,
        newsHead,
        thanksHead,
        bannerImg,
        footer,
        fouceData,
        shootOld,
        shootNew,
        group,
        knockout,
        headlinesAd,
        thanksAd,
    } = content;

    return (
        <>
            <Logo />
            <Chip id="260476" type="struct" title="导航" content={nav}>
                <Nav />
            </Chip>
            <div className={styles.layout}>
                <div className={styles.column}>
                    <div className={styles.column_l}>
                        <Chip id="287332" type="recommend" title="焦点图" content={slider}>
                            <Slider />
                        </Chip>
                        <div className={styles.space_30} />
                        <Headlines headlines1={headlines1} headlines2={headlines2} headlinesAd={headlinesAd} />
                    </div>
                    <div className={styles.column_r}>
                        <Schedule scheduleData={fouceData} scheduleHead={scheduleHead} />
                        <div className={styles.space_28} />
                        <ShooterList shootNew={shootNew} shootOld={shootOld} shooteHead={shooteHead} />
                        <div className={styles.space_30} />
                        <Original originalHead={originalHead} originalFeed={originalFeed} />
                        <div className={styles.space_29} />
                        <VideoColumn videoColumnHead={videoColumnHead} videoColumnFeed={videoColumnFeed} />
                    </div>
                </div>
                <div className={styles.space_30} />
                <div className={styles.column}>
                    <Integral tabNameHead={tabNameHead} group={group} knockout={knockout} />
                </div>
                <div className={styles.column}>
                    <Chip id="260486" type="struct" title="通栏广告广告" content={bannerImg}>
                        <BannerAd />
                    </Chip>
                </div>
                <div className={styles.space_30} />
                <div className={styles.column}>
                    <Wonderful wonderfulData={wonderful} wonderfulHead={wonderfulHead} />
                </div>
                <div className={styles.space_30} />
                <div className={styles.column}>
                    <Customer customerData={customer} customerHead={customerHead} />
                </div>
                <div className={styles.space_30} />
                <div className={styles.column}>
                    <News newsData={news} newsHead={newsHead} />
                </div>
                <div className={styles.space_30} />
                <div className={styles.column}>
                    <Thanks thanksHead={thanksHead} thanksAd={thanksAd} />
                </div>
            </div>
            <div className={styles.space_90} />
            <div className={styles.column}>
                <Footer content={footer} />
            </div>
            <ChipEdit transform={chipDataTransform} />
        </>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
